export default function MultiClass( ...classes ) {
    return class {
        constructor (args) {
            classes.forEach(C => Object.assign(this, new C(args)));
        }
    }
}


